import styled, { css } from 'styled-components'

import { breakpoint } from '@sketch/global-styles'

// Components
import { Spinner } from '@sketch/components'
import { BlurUpImage } from '@sketch/modules-common'
import ArtboardInspector from 'modules/shares/Inspector/ArtboardInspector'

// Types
interface ContainerProps {
  cursor: string
}

interface ArtboardContainerProps {
  width: number
  height: number
  isPage: boolean
}

interface ScrollAreaProps {
  itemWidth: number
  itemHeight: number
  containerWidth: number
  containerHeight: number
}

interface ArtboardImageProps {
  isPage: boolean
  srcSet?: string | null
}

// Styles
const Container = styled.div<ContainerProps>`
  position: relative;
  display: flex;
  width: 100%;
  height: 100%;
  overflow: auto;

  cursor: ${({ cursor }) => cursor};

  padding: 20px;

  ${breakpoint('sm')`
    padding: 40px;
  `}
`

const ScrollArea = styled.div<ScrollAreaProps>`
  display: inline-block;
  margin: auto;
`

const ArtboardContainer = styled.div<ArtboardContainerProps>(
  ({ theme, width, height, isPage }) => css`
    position: relative;
    width: ${width}px;
    height: ${height}px;
    background-color: ${theme.colors.background.secondary.A};
    box-shadow: 0 0 2px 0 ${theme.colors.shadow.outer},
      0 2px 4px 0 ${theme.colors.shadow.outer};
    user-select: none;
  `
)

const ArtboardImage = styled(BlurUpImage).attrs(
  (props: ArtboardImageProps) => ({
    loadingStyle: { backgroundColor: props.isPage ? 'transparent' : 'white' },
    brokenStyle: { backgroundColor: props.isPage ? 'transparent' : 'white' },
  })
)<ArtboardImageProps>`
  position: relative;
  top: 0;
  left: 0;
  height: 100%;
`

const Inspector = styled(ArtboardInspector)`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`

const ArtboardSpinner = styled(Spinner)`
  align-self: center;
  margin: auto;
`

export {
  ArtboardContainer,
  ArtboardImage,
  ArtboardSpinner,
  Container,
  Inspector as ArtboardInspector,
  ScrollArea,
}
